<script lang="ts">
  // 사용자 평판/레벨 배지 컴포넌트
  interface Props {
    level: number;
    levelName: string;
    reputationScore: number;
    badgeCount?: number;
    showProgress?: boolean;
    levelProgress?: number;
    size?: 'sm' | 'md' | 'lg';
  }

  let { 
    level, 
    levelName, 
    reputationScore, 
    badgeCount = 0,
    showProgress = false,
    levelProgress = 0,
    size = 'md'
  }: Props = $props();

  // 레벨별 색상
  const levelColors: Record<number, string> = {
    1: 'bg-gray-100 text-gray-600 border-gray-300',
    2: 'bg-green-50 text-green-700 border-green-300',
    3: 'bg-blue-50 text-blue-700 border-blue-300',
    4: 'bg-indigo-50 text-indigo-700 border-indigo-300',
    5: 'bg-purple-50 text-purple-700 border-purple-300',
    6: 'bg-pink-50 text-pink-700 border-pink-300',
    7: 'bg-rose-50 text-rose-700 border-rose-300',
    8: 'bg-orange-50 text-orange-700 border-orange-300',
    9: 'bg-amber-50 text-amber-800 border-amber-400',
    10: 'bg-yellow-50 text-yellow-800 border-yellow-400'
  };

  // 레벨별 아이콘
  const levelIcons: Record<number, string> = {
    1: '🌱', 2: '🌿', 3: '🪴', 4: '🌳', 5: '⭐',
    6: '🌟', 7: '💫', 8: '✨', 9: '🏆', 10: '👑'
  };

  const colorClass = $derived(levelColors[level] || levelColors[1]);
  const icon = $derived(levelIcons[level] || '🌱');

  const sizeClasses = {
    sm: 'text-xs px-1.5 py-0.5',
    md: 'text-sm px-2 py-1',
    lg: 'text-base px-3 py-1.5'
  };
</script>

<div class="inline-flex items-center gap-2">
  <!-- 레벨 배지 -->
  <span 
    class="inline-flex items-center gap-1 rounded-full border font-medium {colorClass} {sizeClasses[size]}"
    title="Lv.{level} {levelName} · {reputationScore.toLocaleString()}점"
  >
    <span>{icon}</span>
    <span>Lv.{level}</span>
  </span>

  <!-- 평판 점수 (옵션) -->
  {#if size !== 'sm'}
    <span class="text-gray-500 {size === 'lg' ? 'text-sm' : 'text-xs'}">
      {reputationScore.toLocaleString()}점
    </span>
  {/if}

  <!-- 배지 수 (옵션) -->
  {#if badgeCount > 0 && size !== 'sm'}
    <span 
      class="inline-flex items-center gap-0.5 text-amber-600 {size === 'lg' ? 'text-sm' : 'text-xs'}"
      title="{badgeCount}개의 배지"
    >
      🏅 {badgeCount}
    </span>
  {/if}
</div>

<!-- 레벨 진행 바 (옵션) -->
{#if showProgress}
  <div class="mt-1 w-full">
    <div class="h-1.5 bg-gray-200 rounded-full overflow-hidden">
      <div 
        class="h-full bg-gradient-to-r from-indigo-500 to-purple-500 transition-all duration-300"
        style="width: {levelProgress}%"
      ></div>
    </div>
    <p class="text-xs text-gray-400 mt-0.5">다음 레벨까지 {(100 - levelProgress).toFixed(1)}%</p>
  </div>
{/if}
